import '../../../style/mobile/store/MspTab3.scss';
import icon1 from '../../../../assets/mobile/store/note-2.svg';
import icon2 from '../../../../assets/mobile/store/vuesax-linear-video-square.svg';
import icon3 from '../../../../assets/mobile/store/vuesax-linear-ticket-discount.svg';
import { Link } from 'react-router-dom';


const MspTab3=({data})=>{

  let Data = data.files;
  return(
    <div className="MspTab3">
      <div className="MspTab3-title">
        فایل‌های مورد نیاز برای شرکت در آزمون
      </div>
      <div className="MspTab3-item1">
        <div className="MspTab3-item-icon-container">
          <img src={icon1} alt="icon1" />
        </div>
        <div className="MspTab3-item1-text">
          <div className="MspTab3-item1-text-title">
            مخصوص فایل های متنی از جمله پی دی اف و ورد
          </div>
          {Data[0].map(item=>(
            <div className="MspTab3-item1-text-item">
              {item.text}
            </div>
          ))}
        </div>
      </div>
      <div className="MspTab3-item2">
        <div className="MspTab3-item2-icon-container">
          <img src={icon2} alt="icon1" />
        </div>
        <div className="MspTab3-item2-text">
          <div className="MspTab3-item2-text-title">
            قسمت برای فایل های ویدئویی و صوتی
          </div>
          {Data[1].map(item=>(
            <div className="MspTab3-item2-text-item">
              <Link to={data.path}>{item.text}</Link>
            </div>
          ))}
        </div>
      </div>
      <div className="MspTab3-discount">
        <div className="MspTab3-discount-text">
          این آزمون رو به دوست معرفی کن و کد تخفیف 20 درصد بگیر
        </div>
        <img src={icon3} alt="" className="MspTab3-discount-icon" />
      </div>
    </div>
  )
}

export default MspTab3;